import React, { useState } from 'react';
import {
  exportCasesCsv,
  exportViolationsCsv,
  exportPermitsCsv,
  downloadCsv,
} from '../api/govopsOperationsService';
import { formatGovOpsError } from '../api/govopsErrors';
import { PAYMENT_STATUS_OPTIONS } from '../utils/feeFields';
import { formatPaymentStatus } from '../constants/workflowLabels';

const ExportCenter = () => {
  const [busy, setBusy] = useState('');
  const [err, setErr] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');

  const run = async (key, fn, name) => {
    setBusy(key);
    setErr('');
    try {
      const csv = await fn();
      downloadCsv(name, csv);
    } catch (e) {
      setErr(formatGovOpsError(e));
    } finally {
      setBusy('');
    }
  };

  const permitExport = () => {
    const query = paymentStatus ? { paymentStatus } : {};
    return exportPermitsCsv(query);
  };

  return (
    <div className="rhs-export-center">
      <h3>Export center</h3>
      <p className="rhs-muted">Download operational reports for records in your organization.</p>
      {err && (
        <p className="rhs-error" role="alert">
          {err}
        </p>
      )}

      <label htmlFor="export-payment-filter">Filter permits by payment status (optional)</label>
      <select
        id="export-payment-filter"
        className="rhs-input rhs-export-filter"
        value={paymentStatus}
        onChange={(e) => setPaymentStatus(e.target.value)}
        disabled={Boolean(busy)}
      >
        <option value="">All payment statuses</option>
        {PAYMENT_STATUS_OPTIONS.map((s) => (
          <option key={s} value={s}>
            {formatPaymentStatus(s)}
          </option>
        ))}
      </select>

      <div className="rhs-export-actions">
        <button
          type="button"
          className="rhs-btn"
          disabled={Boolean(busy)}
          onClick={() => run('permits', permitExport, 'robinhoodspace-permits.csv')}
        >
          {busy === 'permits' ? 'Exporting…' : 'Export permits (CSV)'}
        </button>
        <button
          type="button"
          className="rhs-btn"
          disabled={Boolean(busy)}
          onClick={() => run('cases', exportCasesCsv, 'robinhoodspace-cases.csv')}
        >
          {busy === 'cases' ? 'Exporting…' : 'Export cases (CSV)'}
        </button>
        <button
          type="button"
          className="rhs-btn"
          disabled={Boolean(busy)}
          onClick={() => run('violations', exportViolationsCsv, 'robinhoodspace-violations.csv')}
        >
          {busy === 'violations' ? 'Exporting…' : 'Export violations (CSV)'}
        </button>
      </div>
    </div>
  );
};

export default ExportCenter;
